import scenarioImages from '../scenarioImages'

export default {
  slug: 'gnm12b',
  title: 'GNM12-B',
  i18nKey: 'AutomotiveGnssProducts.gnm12b',
  images: {
    hero: require('@/assets/images/pixso-automotive-detail/gnm12b-hero.png'),
    description: require('@/assets/images/pixso-automotive-detail/gnm12b-description.png'),
    feature: require('@/assets/images/pixso-automotive-detail/gnm12b-feature.jpg')
  },
  descriptionTags: [
    { key: 'interface', image: require('@/assets/images/pixso-automotive-detail/icon-interface.svg') },
    { key: 'gnss', image: require('@/assets/images/pixso-automotive-detail/icon-gnss.svg') },
    { key: 'rtk', image: require('@/assets/images/pixso-automotive-detail/icon-rtk.svg') }
  ],
  featureTags: [
    { key: 'certification', image: require('@/assets/images/pixso-automotive-detail/icon-certification.svg') },
    { key: 'allFrequency', image: require('@/assets/images/pixso-automotive-detail/icon-allfrequency.svg') },
    { key: 'antiInterference', image: require('@/assets/images/pixso-automotive-detail/icon-antiinterference.svg') },
    { key: 'flexibleExpansion', image: require('@/assets/images/pixso-automotive-detail/icon-flexibleexpansion.svg') }
  ],
  scenarios: [
    {
      key: 'tunnelFork',
      image: scenarioImages.tunnelFork
    },
    {
      key: 'parking',
      image: scenarioImages.parking
    },
    {
      key: 'overpass',
      image: scenarioImages.overpass
    },
    {
      key: 'urbanCanyon',
      image: scenarioImages.urbanCanyon
    },
    {
      key: 'complexTraffic',
      image: scenarioImages.complexTraffic
    },
    {
      key: 'treeLinedStreet',
      image: scenarioImages.treeLinedStreet
    }
  ],
  specTabs: [
    {
      labelKey: 'ProductSpecs.tabs.basic',
      rows: [
        { labelKey: 'ProductSpecs.rows.dimensionsWithEars', value: '99x99x26mm' },
        { labelKey: 'ProductSpecs.rows.weightBare', value: '157±20g' },
        {
          labelKey: 'ProductSpecs.rows.dataInterface',
          value: [
            { valueKey: 'ProductSpecs.values.rtcmGgaOutput' },
            { valueKey: 'ProductSpecs.values.insGnssImuOutput' }
          ]
        },
        { labelKey: 'ProductSpecs.rows.sleepMode', value: { valueKey: 'ProductSpecs.values.supported' } },
        { labelKey: 'ProductSpecs.rows.operatingVoltage', value: '9-16V' },
        { labelKey: 'ProductSpecs.rows.operatingCurrent', value: '≤0.2A@12V' },
        { labelKey: 'ProductSpecs.rows.operatingTemperature', value: { valueKey: 'ProductSpecs.values.operatingTemperatureOptional' } },
        { labelKey: 'ProductSpecs.rows.protectionRating', value: 'IP66' }
      ]
    },
    { labelKey: 'ProductSpecs.tabs.antenna', rows: [] },
    { labelKey: 'ProductSpecs.tabs.gnss', rows: [] },
    { labelKey: 'ProductSpecs.tabs.gyroAccelerometer', rows: [] },
    { labelKey: 'ProductSpecs.tabs.gnssDeniedIns', rows: [] }
  ]
}
